import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import { Layout, Button, Input, Select,Pagination } from "element-react";
import Navigation from "../../components/navigation";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"

require("./index.scss");

export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      ddlData: [
        { value: "1", label: "退役军人服务中心" },
        { value: "2", label: "退役军人服务站" },
        { value: "3", label: "军休服务管理机构" },
        { value: "4", label: "双拥事业单位" },
        { value: "5", label: "优抚事业单位" },
        { value: "6", label: "教育培训机构" },
        { value: "7", label: "就业创业基地" },

      ],
      maplist: [],
      serviceStationType:1,
      data:{},
    };
  }

  componentDidMount = () => {
    const { BMap } = window;
    let map = new BMap.Map("map"); //创建Map实例   
    map.addControl(new BMap.NavigationControl());//添加控制器
    var point = new BMap.Point(111.62299, 40.80772); //定义一个中心点坐标
    map.centerAndZoom(point, 11); //设定地图的中心点和坐标并将地图显示在地图容器中
    var marker = new BMap.Marker(point); // 创建标注
    map.addOverlay(marker); // 将标注添加到地图中
    map.enableScrollWheelZoom()//允许鼠标滚轮放大缩小
    
    let params = {
      serviceStationType:1,
       current:1,
       size:6
    }
    Http.get(Request.getOfficArea(),params,obj=>{
      if(obj.code == 200){
        console.log(obj);
        this.setState({
          maplist:obj.data.records,
          data:obj.data
        })
      }
    })
  }

  handlePoint = (x, y) => {
    const { BMap } = window;
    let map = new BMap.Map("map");
    map.addControl(new BMap.NavigationControl());//添加控制器
    var point = new BMap.Point(x, y);
    map.centerAndZoom(point, 11);
    var marker = new BMap.Marker(point);
    map.addOverlay(marker);
    map.enableScrollWheelZoom()//允许鼠标滚轮放大缩小
  }

  onChange = (val) => {
    console.log(val)
   this.setState({serviceStationType:val});
    let params = {
      serviceStationType:val,
      current:1,
      size:6
    }
    Http.get(Request.getOfficArea(),params,obj=>{
      if(obj.code == 200){
        console.log(obj);
        this.setState({
          maplist:obj.data.records,
          data:obj.data
        })
      }
    })
  }
  onCurrentChange=(page)=>{
   let {serviceStationType}= this.state;
    let params = {
      serviceStationType:serviceStationType,
      current:page,
      size:6
    }
    Http.get(Request.getOfficArea(),params,obj=>{
      if(obj.code == 200){
        console.log(obj);
        this.setState({
          maplist:obj.data.records,
          data:obj.data
        })
      }
    })
  }
  render() {
    let { ddlData, maplist,data } = this.state;
    return (

      <div className="map_cont container clear">
        <Navigation />
        <div className="map_cont_left">
          <div>
            <div>
              <Select onChange={(e) => this.onChange(e)}>
                {ddlData.map(el => {
                  return (
                    <Select.Option
                      key={el.value}
                      label={el.label}
                      value={el.value}
                    />
                  );
                })}
              </Select>
              {/* <div className="btn_box">
                <Button>搜索</Button>
              </div> */}
            </div>


            <div className="result_list"  >
              <ul style={{ "height": "630px", "marginTop": "20px", "overflow": "auto" }}>
                {maplist && maplist.length > 0 ? maplist.map((item, i) => {
                  return (
                    <li key={i} onClick={() => this.handlePoint(item.xpoint, item.ypoint)} style={{ cursor: 'pointer' }}>
                      <div style={{ "display": "flex", "alignItems": "center" }}><div className="sortNum">{i+1}</div>
                        <div>{item.name}</div></div>
                      <div>{item.address}</div>
                      <div>{item.phone}</div>
                    </li>
                  )
                }) : <div>暂无数据</div>}
              </ul>
              <Pagination layout="prev, pager, next" pageSize={6} total={data.total} small={true} onCurrentChange={this.onCurrentChange}/>
            </div>
          
          </div>

        </div>
        <div className="map_cont_right">
          <div id="map" style={{ width: "892px", height: "706px" }}></div>
        </div>
      </div>

    );
  }
}
